import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '@structural-climbing/auth'
import { CompetitionsSection } from '../features/competitions/CompetitionsSection'
import type { Competition } from '../features/competitions/types'

export function CompetitionsPage() {
  const { getAccessTokenSilently } = useAuth()
  const apiUrl = import.meta.env.VITE_API_URL as string

  const [competitions, setCompetitions] = useState<Competition[]>([])
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const token = await getAccessTokenSilently()
      const res = await fetch(`${apiUrl}/competitions`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      if (res.ok) setCompetitions((await res.json()) as Competition[])
    } finally {
      setLoading(false)
    }
  }, [apiUrl, getAccessTokenSilently])

  useEffect(() => {
    void load()
  }, [load])

  return (
    <div className="p-4 sm:p-8">
      <CompetitionsSection competitions={competitions} loading={loading} />
    </div>
  )
}
